import { styled } from 'stitches.config'

export const CircleRoot = styled('div', {
  size: '$5',
  borderRadius: '$round',
  borderStyle: 'solid',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  variants: {
    variant: {
      primary: {
        backgroundColor: '$tertiary-200',
        borderColor: '$primary-500',
        color: '$primary-700',
      },
      secondary: {
        backgroundColor: '$tertiary-200',
        borderColor: '$tertiary-200',
        color: '$primary-700',
      },
    },
    border: {
      regular: {
        borderWidth: '1px',
      },
      thick: {
        borderWidth: '3px',
      },
    },
  },

  defaultVariants: {
    border: 'regular',
  },
})
